import { combineReducers } from "redux";
const serviceReportList = (state = { data: [], processData: {} }, action) => {
  switch (action.type) {
    case "SERVICE_REPORTLIST":
      const curKeys = Object.keys(state.processData);
      const lastKeys = curKeys[curKeys.length - 1];
      const newKeys = Object.keys(action.data.processData);
      const newFiratKeys = newKeys[0];
      if (lastKeys == newFiratKeys) {
        console.log('lastKeys == newFiratKeys')
        action.data.processData[newFiratKeys].unshift(...state.processData[lastKeys]);
      }
      console.log('11111111',action.data.processData)
      return {
        ...action.data,
        data: [...state.data, ...action.data.data],
        processData: { ...state.processData, ...action.data.processData },
      };

    case "LIST_DEL":
      return { data: [], processData: {} };
    default:
      return state;
  }
};
const serviceReporDetail = (state = null, action) => {
  switch (action.type) {
    case "SERVICE_REPORTDETAIL":
      return action.data;
    case "DEL":
      return {};
    default:
      return state;
  }
};
const serviceReportReducer = combineReducers({
  serviceReportList,
  serviceReporDetail,
});

export default serviceReportReducer;



// WEBPACK FOOTER //
// ./src/reducer/serviceReportReducer.js